<template>
  <v-card style="position:relative;">
    <v-toolbar
      dark
      color="primary"
      v-if="campo.cmp_tipo != '' && campo.cmp_tipo != null"
    >
      <v-btn icon dark @click.native="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Campo: {{ campo.cmp_titulo }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-if="campo.cmp_coluna != '' && campo.cmp_titulo != ''">
        <v-btn dark flat @click="gravar()">Salvar</v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-toolbar
      color="green"
      v-if="campo.cmp_tipo == '' || campo.cmp_tipo == null"
    >
      <v-btn icon @click.native="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Campo: {{ campo.cmp_titulo }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-if="witype">
        <v-btn flat @click="escolher()">Prosseguir</v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <form v-if="campo.cmp_tipo == '' || campo.cmp_tipo == null">
      <v-card class="pa-2 ma-2" dark>
        <h3 class="text-xs-left">Wizard de Criação de Campo</h3>
        <v-layout row wrap>
          <v-flex xs6 class="pa-1">
            <v-radio-group v-model="witype">
              <v-radio
                class="body-1"
                v-for="(w, wi) of wizard"
                :key="wi"
                :label="w.nome"
                :value="w"
              ></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex xs6 class="pa-1">
            <v-radio-group v-model="witype">
              <v-radio
                class="body-1"
                v-for="(w, wi) of wizard2"
                :key="wi"
                :label="w.nome"
                :value="w"
              ></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-card>
    </form>

    <form v-if="campo.cmp_tipo != '' && campo.cmp_tipo != null">
      <v-card class="pa-2 ma-2" dark>
        <h3 class="text-xs-left">Informações gerais</h3>
        <v-layout row wrap>
          <v-flex xs3 class="pa-1">
            <v-text-field
              v-model="campo.cmp_titulo"
              :counter="32"
              label="Título"
              hint="(Nome do campo)"
              persistent-hint
            ></v-text-field>

            <v-text-field
              v-for="(en, ei) of extrasnovos"
              :key="ei"
              v-model="en.titulo"
              :counter="32"
              label="Título"
              hint="(Nome do campo)"
              persistent-hint
            ></v-text-field>
          </v-flex>

          <v-flex xs3 class="pa-1" style="position:relative;">
            <v-text-field
              v-model="campo.cmp_coluna"
              label="Coluna"
            ></v-text-field>

            <v-text-field
              v-for="(en, ei) of extrasnovos"
              :key="ei"
              v-model="en.coluna"
              label="Coluna"
            ></v-text-field>

            <v-btn
              color="blue"
              @click="addColuna()"
              dark
              absolute
              top
              right
              small
              fab
              style="zoom: 40%; '-moz-transform': 'scale(40%)';"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </v-flex>

          <v-flex
            class="caption"
            xs2
            v-for="(no, i) in [
              { col: 'cmp_pk', nome: 'Pk', icon: 'home' },
              { col: 'cmp_add', nome: 'Add' },
              { col: 'cmp_edit', nome: 'Edit' },
              { col: 'cmp_view', nome: 'View' },
              { col: 'cmp_lista', nome: 'Listar' },
              { col: 'cmp_filtro', nome: 'Filtrar' },
              { col: 'cmp_ordem', nome: 'Order' },
              { col: 'cmp_viewmode', nome: 'VM' },
              { col: 'cmp_idioma', nome: 'Lang' }
            ]"
            :key="i"
          >
            <v-switch
              class="ma-1 pa-1 caption elevation-2"
              :append-icon="no.icon"
              :color="campo[no.col] ? 'red' : 'grey'"
              :label="no.nome"
              v-model="campo[no.col]"
            ></v-switch>
          </v-flex>
        </v-layout>
      </v-card>

      <v-card class="pa-1 ma-2">
        <v-layout row wrap>
          <v-flex xs3 class="pa-1">
            <v-select
              :items="typelist"
              label="Type"
              v-model="campo.cmp_type"
            ></v-select>
          </v-flex>

          <v-flex xs3 class="pa-1">
            <v-text-field
              v-model="campo.cmp_tamanho"
              label="Tamanho"
            ></v-text-field>
          </v-flex>

          <v-flex xs6 class="pa-1">
            <v-text-field v-model="campo.cmp_dica" label="Dica"></v-text-field>
          </v-flex>

          <v-flex xs6 class="pa-1">
            <v-text-field
              v-model="campo.cmp_valida"
              label="Validação"
            ></v-text-field>

            <a href="javascript:;" @click="campo.cmp_valida = ''">Livre</a> |
            <a
              href="javascript:;"
              @click="
                campo.cmp_valida = '[v => !!v || titulo+\' obrigatório\']'
              "
              >NotNull</a
            >
            |
            <a
              href="javascript:;"
              @click="
                campo.cmp_valida =
                  '[v => (v!==null && v!==\'\') || titulo+\' obrigatório\']'
              "
              >Select</a
            >
            |
            <a
              href="javascript:;"
              @click="
                campo.cmp_valida =
                  '[v => v.length>0 || titulo+\' obrigatório\']'
              "
              >NxN</a
            >
          </v-flex>

          <v-flex xs3 class="pa-1">
            <v-select
              :items="['', 'ASC', 'DESC']"
              label="Ordem default"
              v-model="campo.cmp_ordena"
            ></v-select>
          </v-flex>

          <v-flex xs3 class="pa-1">
            <v-text-field
              v-model="campo.valorpadrao"
              label="Valor padrão"
            ></v-text-field>
          </v-flex>

          <v-flex xs4 class="pa-1">
            <v-text-field
              v-model="campo.cmp_conta"
              label="Conta"
            ></v-text-field>
          </v-flex>

          <v-flex xs4 class="pa-1">
            <v-text-field
              v-model="campo.cmp_showfn"
              label="Função de exibição"
            ></v-text-field>
          </v-flex>

          <v-flex xs4 class="pa-1">
            <v-text-field
              v-model="campo.cmp_manual"
              label="Campo manual"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card>

      <v-card class="pa-1 ma-2" dark>
        <v-layout row wrap>
          <v-flex xs3 class="pa-1">
            <v-select
              :items="tipocampo"
              label="Tipo"
              v-model="campo.cmp_tipo"
            ></v-select>
          </v-flex>

          <v-flex
            xs9
            class="pa-1"
            v-if="campo.cmp_tipo == 'select' || campo.cmp_tipo == 'radio'"
          >
            <v-text-field
              v-model="campo.cmp_valores"
              label="Valores"
            ></v-text-field>
          </v-flex>

          <v-flex
            xs3
            class="pa-1"
            v-if="campo.cmp_tipo == 'componente' || campo.cmp_tipo == 'join'"
          >
            <v-select
              :items="componentes"
              label="Componente"
              v-model="campo.componente"
            ></v-select>
          </v-flex>

          <v-flex xs6 class="pa-1">
            <v-textarea
              v-model="campo.param"
              label="Parâmetros"
              hint="chave=valor. Separados por \\n"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-card>

      <v-card class="pa-1 ma-2" v-if="campo.cmp_tipo == 'foto'">
        <h3 class="text-xs-left">Dados das Imagens</h3>

        <v-btn
          color="pink"
          dark
          small
          absolute
          right
          top
          fab
          @click="addFoto(campo)"
        >
          <v-icon>add</v-icon>
        </v-btn>

        <span v-for="(f, ix) of campo.fotos || []" :key="ix">
          <v-layout row wrap>
            <v-flex xs3 class="pa-1">
              <v-text-field v-model="f.fot_x" label="Largura"></v-text-field>
            </v-flex>
            <v-flex xs3 class="pa-1">
              <v-text-field v-model="f.fot_y" label="Altura"></v-text-field>
            </v-flex>
            <v-flex xs3 class="pa-1">
              <v-text-field
                v-model="f.fot_prefixo"
                label="Prefixo"
              ></v-text-field>
            </v-flex>
            <v-flex xs3 class="pa-1">
              <v-btn
                color="pink"
                dark
                small
                absolute
                right
                fab
                @click="dropFoto(ix)"
                style="zoom: 40%; '-moz-transform': 'scale(40%)'"
              >
                <v-icon>remove</v-icon>
              </v-btn>

              <v-text-field
                v-model="f.fot_qualidade"
                label="Qualidade"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </span>
      </v-card>

      <v-card class="pa-1 ma-2" v-if="campo.cmp_tipo == 'arquivo'">
        <h3 class="text-xs-left">Dados do Anexo</h3>

        <v-layout row wrap>
          <v-flex xs4 class="pa-1">
            <v-text-field v-model="campo.arq_tipo" label="Tipo"></v-text-field>
          </v-flex>
          <v-flex xs4 class="pa-1">
            <v-text-field
              v-model="campo.arq_mime"
              label="Mime-Type"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 class="pa-1">
            <v-text-field
              v-model="campo.arq_maxsize"
              label="MaxSize"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card>

      <v-card class="pa-1 ma-2" v-if="campo.cmp_tipo == 'join'">
        <h3 class="text-xs-left">JOIN</h3>

        <v-layout row wrap>
          <v-flex xs4 class="pa-1">
            <v-select
              :items="joins"
              item-text="tabela"
              item-value="tabela"
              label="Tabela"
              v-model="campo.cmp_join_tabela"
            ></v-select>
          </v-flex>
          <v-flex xs4 class="pa-1">
            <v-select
              :items="selectedcols"
              label="Campo"
              v-model="campo.cmp_join_campo"
            ></v-select>
          </v-flex>
          <v-flex xs4 class="pa-1">
            <v-select
              :items="selectedcols"
              label="Mostra"
              v-model="campo.cmp_join_mostra"
            ></v-select>
          </v-flex>
          <v-flex xs12 class="pa-1">
            <v-text-field
              label="Manual Select SQL (mostrar)"
              v-model="campo.cmp_join_mostra"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 class="pa-1">
            <v-select
              :items="tipojoin"
              label="Tipo de Join"
              v-model="campo.cmp_join_tipo"
            ></v-select>
          </v-flex>
          <v-flex xs8 class="pa-1">
            <v-textarea
              label="Restrição(Opcional)"
              v-model="campo.cmp_join_restricao"
            ></v-textarea>
          </v-flex>

          <v-flex
            xs4
            class="pa-1"
            v-if="
              campo.cmp_join_tipo == 'NxN' ||
                campo.cmp_join_tipo == 'NxN checkbox'
            "
          >
            <v-text-field
              label="Tabela NxN"
              v-model="campo.cmp_join_tabelann"
            ></v-text-field>
          </v-flex>
          <v-flex
            xs4
            class="pa-1"
            v-if="
              campo.cmp_join_tipo == 'NxN' ||
                campo.cmp_join_tipo == 'NxN checkbox'
            "
          >
            <v-text-field
              label="Chave1"
              v-model="campo.cmp_join_tabelac1"
            ></v-text-field>
          </v-flex>
          <v-flex
            xs4
            class="pa-1"
            v-if="
              campo.cmp_join_tipo == 'NxN' ||
                campo.cmp_join_tipo == 'NxN checkbox'
            "
          >
            <v-text-field
              label="Chave2"
              v-model="campo.cmp_join_tabelac2"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card>

      <v-card class="pa-1 ma-2">
        <v-layout row wrap>
          <v-flex xs4 class="pa-1">
            <hr />
            <v-text-field
              v-model="campo.cmp_extra"
              label="Extra"
              hint="INDEX,FK,UNIQUE,NOTNULL"
              persistent-hint
              placeholder="Definicoes especiais"
            ></v-text-field>
          </v-flex>

          <v-flex xs8 class="pa-1">
            <hr />
            <v-text-field
              v-model="campo.cmp_flow"
              label="Flow"
              hint="estados de fluxo onde deve aparecer (separado por vírgulas)"
              persistent-hint
              placeholder
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card>
    </form>

    <v-toolbar
      dark
      color="primary"
      v-if="campo.cmp_tipo != '' && campo.cmp_tipo != null"
    >
      <v-spacer></v-spacer>
      <v-toolbar-items v-if="campo.cmp_coluna != '' && campo.cmp_titulo != ''">
        <v-btn dark flat @click="gravar()">Salvar</v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </v-card>
</template>

<script>
/* eslint-disable */
import _ from "lodash";

const componentes = [];
for (let cnome of global.reqClass.componentes_client) {
  if (cnome.substr(0, 2) == "c-") componentes.push(cnome.substr(2));
}

export default {
  props: ["campo", "modulo"],
  data() {
    return {
      witype: "",
      typelist: [
        "VARCHAR",
        "INT",
        "TEXT",
        "DOUBLE",
        "DATETIME",
        "FLOAT",
        "BOOLEAN"
      ],
      extrasnovos: [],
      tipocampo: [
        "text",
        "select",
        "radio",
        "switch",
        "password",
        "textarea",
        "textareabasic",
        "date",
        "datetime",
        "foto",
        "arquivo",
        "join",
        "manual",
        "componente"
      ],
      componentes,
      joins: [],
      tipojoin: ["select", "radio", "NxN", "NxN checkbox"],
      tabacao: 0,
      wizard: [
        {
          nome: "Chave primária",
          model: {
            cmp_titulo: "Código",
            cmp_coluna: "id",
            cmp_type: "INT",
            cmp_pk: true,
            cmp_add: false,
            cmp_edit: false,
            cmp_view: false,
            cmp_lista: false,
            cmp_filtro: false,
            cmp_ordem: false,
            cmp_tipo: "text"
          }
        },

        {
          nome: "Campo de texto comum",
          model: {
            cmp_type: "VARCHAR",
            cmp_tamanho: "255",
            cmp_pk: false,
            cmp_add: true,
            cmp_edit: true,
            cmp_view: true,
            cmp_lista: true,
            cmp_filtro: true,
            cmp_ordem: true,
            cmp_tipo: "text"
          }
        },
        {
          nome: "Caixa de texto multi-linhas (textarea)",
          model: {
            cmp_type: "TEXT",
            cmp_pk: false,
            cmp_add: true,
            cmp_edit: true,
            cmp_view: true,
            cmp_lista: false,
            cmp_filtro: true,
            cmp_ordem: false,
            cmp_tipo: "textareabasic"
          }
        },
        {
          nome: "Caixa de texto multi-linhas (Basico)",
          model: {
            cmp_type: "TEXT",
            cmp_pk: false,
            cmp_add: true,
            cmp_edit: true,
            cmp_view: true,
            cmp_lista: false,
            cmp_filtro: true,
            cmp_ordem: false,
            cmp_tipo: "componente",
            componente: "cleditor"
          }
        },
        {
          nome: "Caixa de texto multi-linhas (Completo)",
          model: {
            cmp_type: "TEXT",
            cmp_pk: false,
            cmp_add: true,
            cmp_edit: true,
            cmp_view: true,
            cmp_lista: false,
            cmp_filtro: true,
            cmp_ordem: false,
            cmp_tipo: "componente"
          }
        },
        {
          nome: "Campo de senha",
          model: {
            cmp_type: "VARCHAR",
            cmp_tamanho: "255",
            cmp_pk: false,
            cmp_add: true,
            cmp_edit: true,
            cmp_view: true,
            cmp_lista: false,
            cmp_filtro: false,
            cmp_ordem: false,
            cmp_tipo: "password"
          }
        },
        {
          nome: "Campo de upload de imagem",
          model: {
            cmp_type: "TEXT",
            cmp_pk: false,
            cmp_add: true,
            cmp_edit: true,
            cmp_view: true,
            cmp_lista: false,
            cmp_filtro: false,
            cmp_ordem: false,
            cmp_tipo: "foto"
          }
        },
        {
          nome: "Campo de upload de arquivo",
          model: {
            cmp_type: "TEXT",
            cmp_pk: false,
            cmp_add: true,
            cmp_edit: true,
            cmp_view: true,
            cmp_lista: false,
            cmp_filtro: false,
            cmp_ordem: false,
            cmp_tipo: "arquivo",
            arq_tipo: "*"
          }
        },
        {
          nome: "Campo de escolha em lista (select)",
          model: {
            cmp_type: "INT",
            cmp_pk: false,
            cmp_add: true,
            cmp_edit: true,
            cmp_view: true,
            cmp_lista: true,
            cmp_filtro: true,
            cmp_ordem: true,
            cmp_tipo: "select"
          }
        },
        {
          nome: "Campo de escolha em lista (radio)",
          model: {
            cmp_type: "INT",
            cmp_pk: false,
            cmp_add: true,
            cmp_edit: true,
            cmp_view: true,
            cmp_lista: true,
            cmp_filtro: true,
            cmp_ordem: true,
            cmp_tipo: "radio"
          }
        },
        {
          nome: "Campo de relacionamento com outro módulo",
          model: {
            cmp_type: "INT",
            cmp_pk: false,
            cmp_add: true,
            cmp_edit: true,
            cmp_view: true,
            cmp_lista: true,
            cmp_filtro: true,
            cmp_ordem: true,
            cmp_tipo: "join"
          }
        },
        {
          nome: "Campo de multipla escolha (Join NxN)",
          model: {
            cmp_type: "INT",
            cmp_pk: false,
            cmp_add: true,
            cmp_edit: true,
            cmp_view: true,
            cmp_lista: false,
            cmp_filtro: false,
            cmp_ordem: false,
            cmp_tipo: "join",
            cmp_join_tipo: "NxN"
          }
        },
        {
          nome: "Campo de data com calendário",
          model: {
            cmp_type: "DATETIME",
            cmp_pk: false,
            cmp_add: true,
            cmp_edit: true,
            cmp_view: true,
            cmp_lista: true,
            cmp_filtro: true,
            cmp_ordem: true,
            cmp_tipo: "date"
          }
        },
        {
          nome: "Exibição de dados (campo que não fica na tabela)",
          model: {
            cmp_coluna: "*",
            cmp_type: "VARCHAR",
            cmp_tamanho: "255",
            cmp_pk: false,
            cmp_add: false,
            cmp_edit: false,
            cmp_view: false,
            cmp_lista: true,
            cmp_filtro: true,
            cmp_ordem: true,
            cmp_tipo: "text"
          }
        },
        {
          nome: "Componente Personalizado",
          model: {
            cmp_type: "VARCHAR",
            cmp_tamanho: "255",
            cmp_pk: false,
            cmp_add: true,
            cmp_edit: true,
            cmp_view: true,
            cmp_lista: true,
            cmp_filtro: false,
            cmp_ordem: true,
            cmp_tipo: "componente"
          }
        },
        {
          nome: "Customizado",
          model: {
            cmp_type: "VARCHAR",
            cmp_tamanho: "255",
            cmp_pk: false,
            cmp_add: true,
            cmp_edit: true,
            cmp_view: true,
            cmp_lista: true,
            cmp_filtro: true,
            cmp_ordem: true,
            cmp_tipo: "text"
          }
        }
      ],
      wizard2: [
        {
          nome: "Criado Por (created_by)",
          model: {
            cmp_titulo: "Criado Por",
            cmp_coluna: "created_by",
            cmp_type: "INT",
            cmp_pk: false,
            cmp_add: false,
            cmp_edit: false,
            cmp_view: true,
            cmp_lista: true,
            cmp_filtro: true,
            cmp_ordem: false,
            cmp_tipo: "join",
            cmp_join_tabela: global.config.pessoa,
            cmp_join_campo: "id",
            cmp_join_mostra: "nome",
            cmp_join_restricao: ""
          }
        },
        {
          nome: "Modificado Por (last_edit_by)",
          model: {
            cmp_titulo: "Modificado Por",
            cmp_coluna: "last_edit_by",
            cmp_type: "INT",
            cmp_pk: false,
            cmp_add: false,
            cmp_edit: false,
            cmp_view: true,
            cmp_lista: true,
            cmp_filtro: true,
            cmp_ordem: false,
            cmp_tipo: "join",
            cmp_join_tabela: global.config.pessoa,
            cmp_join_campo: "id",
            cmp_join_mostra: "nome",
            cmp_join_restricao: ""
          }
        },
        {
          nome: "Excluido Por (deleted_by)",
          model: {
            cmp_titulo: "Excluido Por",
            cmp_coluna: "deleted_by",
            cmp_type: "INT",
            cmp_pk: false,
            cmp_add: false,
            cmp_edit: false,
            cmp_view: true,
            cmp_lista: true,
            cmp_filtro: true,
            cmp_ordem: false,
            cmp_tipo: "join",
            cmp_join_tabela: global.config.pessoa,
            cmp_join_campo: "id",
            cmp_join_mostra: "nome",
            cmp_join_restricao: ""
          }
        },
        {
          nome: "Criado Em (created_on)",
          model: {
            cmp_titulo: "Criado Em",
            cmp_coluna: "created_on",
            cmp_type: "DATETIME",
            cmp_pk: false,
            cmp_add: false,
            cmp_edit: false,
            cmp_view: true,
            cmp_lista: true,
            cmp_filtro: true,
            cmp_ordem: false,
            cmp_tipo: "datetime"
          }
        },
        {
          nome: "Modificado Em (last_edit_on)",
          model: {
            cmp_titulo: "Modificado Em",
            cmp_coluna: "last_edit_on",
            cmp_type: "DATETIME",
            cmp_pk: false,
            cmp_add: false,
            cmp_edit: false,
            cmp_view: true,
            cmp_lista: true,
            cmp_filtro: true,
            cmp_ordem: false,
            cmp_tipo: "datetime"
          }
        },
        {
          nome: "Excluído Em (deleted_on)",
          model: {
            cmp_titulo: "Excluído Em",
            cmp_coluna: "deleted_on",
            cmp_type: "DATETIME",
            cmp_pk: false,
            cmp_add: false,
            cmp_edit: false,
            cmp_view: true,
            cmp_lista: true,
            cmp_filtro: true,
            cmp_ordem: false,
            cmp_tipo: "datetime"
          }
        },
        {
          nome: "Inativo",
          model: {
            cmp_titulo: "Inativo",
            cmp_coluna: "inativo",
            cmp_type: "INT",
            cmp_pk: false,
            cmp_add: false,
            cmp_edit: false,
            cmp_view: false,
            cmp_lista: false,
            cmp_filtro: false,
            cmp_ordem: false,
            cmp_tipo: "componente",
            componente: "inativo"
          }
        },
        {
          nome: "Auto Ordenação (order_by)",
          model: {
            cmp_titulo: "Ordem de Exibição",
            cmp_coluna: "order_by",
            cmp_type: "INT",
            cmp_pk: false,
            cmp_add: false,
            cmp_edit: false,
            cmp_view: false,
            cmp_lista: false,
            cmp_filtro: false,
            cmp_ordem: false,
            cmp_ordena: "ASC",
            cmp_tipo: "text"
          }
        },
        {
          nome: "URL Amigável (friendly_url)",
          model: {
            cmp_titulo: "Url amigável",
            cmp_coluna: "friendly_url",
            cmp_type: "VARCHAR",
            cmp_tamanho: "255",
            cmp_pk: false,
            cmp_add: false,
            cmp_edit: false,
            cmp_view: false,
            cmp_lista: false,
            cmp_filtro: false,
            cmp_ordem: false,
            cmp_tipo: "text"
          }
        },
        {
          nome: "Controle de Versão (revision)",
          model: {
            cmp_titulo: "Revisão",
            cmp_coluna: "revision",
            cmp_type: "INT",
            cmp_pk: false,
            cmp_add: false,
            cmp_edit: false,
            cmp_view: false,
            cmp_lista: false,
            cmp_filtro: false,
            cmp_ordem: false,
            cmp_ordena: "ASC",
            cmp_tipo: "text"
          }
        },
        {
          nome: "Controle de Versão (revisionid)",
          model: {
            cmp_titulo: "RevisãoOriginal",
            cmp_coluna: "revisionid",
            cmp_type: "INT",
            cmp_pk: false,
            cmp_add: false,
            cmp_edit: false,
            cmp_view: false,
            cmp_lista: false,
            cmp_filtro: false,
            cmp_ordem: false,
            cmp_tipo: "text"
          }
        },
        {
          nome: "Fluxo - Telas",
          model: {
            cmp_titulo: "Fluxo (Tela)",
            cmp_coluna: "flowcontrol",
            cmp_type: "INT",
            cmp_pk: false,
            cmp_add: false,
            cmp_edit: false,
            cmp_view: true,
            cmp_lista: true,
            cmp_filtro: true,
            cmp_ordem: true,
            cmp_tipo: "select",
            cmp_conta: "conta_first_token"
          }
        },
        {
          nome: "Fluxo - Ações",
          model: {
            cmp_titulo: "Fluxo (Ação)",
            cmp_coluna: "flowaction",
            cmp_type: "INT",
            cmp_pk: false,
            cmp_add: false,
            cmp_edit: false,
            cmp_view: false,
            cmp_lista: false,
            cmp_filtro: false,
            cmp_ordem: false,
            cmp_tipo: "select",
            cmp_conta: "conta_first_token"
          }
        }
      ]
    };
  },
  computed: {
    selectedcols() {
      if (!this.campo.cmp_join_tabela) return [];
      let obj = _.find(this.joins, { tabela: this.campo.cmp_join_tabela });

      return obj ? obj.cols || [] : [];
    }
  },
  mounted() {
    this.witype = this.wizard[1];

    /*

        { tabela: "tabela1", cols: ["id", "nome"] },
        { tabela: "tabela2", cols: ["id", "nome"] },
        { tabela: "tabela3", cols: ["id", "nome"] }

        */

    //carregar params para join.

    let all = global.modulosController.modulos;
    let jmap = [];
    for (let m of all) {
      if (m.json.modulo.mod_tabela.indexOf("_v_") != -1) continue; //NAO CRIAR PARA VIEWS

      let no = { tabela: m.json.modulo.mod_tabela, cols: [] };
      for (let n of m.json.campos) {
        no.cols.push(n.cmp_coluna);
      }
      jmap.push(no);
    }
    this.joins = jmap;
    //console.log(jmap);
  },
  methods: {
    add: function(el) {
      console.log(el);
    },
    addColuna() {
      this.extrasnovos.push({
        titulo: this.campo.cmp_titulo,
        coluna: this.campo.cmp_coluna
      });
    },
    addFoto(campo) {
      campo.fotos = campo.fotos || [];
      campo.fotos.push({
        fot_x: "",
        fot_y: "",
        fot_prefixo: "",
        fot_qualidade: "90"
      });
    },
    dropFoto(i) {
      this.campo.fotos.splice(i, 1);
    },
    async gravar() {
      for (var x in this.extrasnovos) {
        if (
          this.extrasnovos[x].titulo != "" &&
          this.extrasnovos[x].coluna != ""
        ) {
          let novo = _.assignIn({}, this.campo);
          novo.cmp_titulo = this.extrasnovos[x].titulo;
          novo.cmp_coluna = this.extrasnovos[x].coluna;
          this.modulo.json.campos.push(novo);
        }
      }
      console.log(this.modulo);

      let res = await global.modulosController.updateRest(
        this.modulo.json.modulo.mod_tabela
      );
      this.$emit("close");
    },
    escolher() {
      for (let x in this.witype.model) this.campo[x] = this.witype.model[x];
    }
  },
  watch: {
    "campo.cmp_pk": function(v) {
      if (v == true) {
        this.campo.cmp_coluna = "id";
      }
    }
  }
};
</script>

<style scoped>
.v-btn {
  margin: 2px;
}
</style>
